import { render, staticRenderFns } from "./TickerSettingsList.vue?vue&type=template&id=19e4f448&scoped=true"
import script from "./TickerSettingsList.vue?vue&type=script&lang=js"
export * from "./TickerSettingsList.vue?vue&type=script&lang=js"
import style0 from "./TickerSettingsList.vue?vue&type=style&index=0&id=19e4f448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e4f448",
  null
  
)

export default component.exports